import classNames from 'classnames'

interface UsageAndCostContainerProps {
    children: React.ReactNode
    className?: string
}

const UsageAndCostContainer: React.FC<UsageAndCostContainerProps> = ({
    children,
    className,
}) => (
    <div
        data-testid="usage-and-cost-container"
        className={classNames(
            'box-border rounded-xl p-4 shadow-inset-1 shadow-neutral-200',
            className
        )}
    >
        {children}
    </div>
)

export default UsageAndCostContainer
